/**
 * Created by sung on 2017-03-10.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,ButtonModule,PaginatorModule, DropdownModule} from "primeng/primeng";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {RouterModule} from "@angular/router";
import { MamAdminService } from '../../service/mam_service.component';
import { MamVisitorService } from '../../service/mam_visitor_service.component';
import { Device } from '../../model/device';
import { Visitor } from '../../model/visitor';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import {ExDialogModule} from "../../component/dialog.component";
import {SearchModule} from "../../component/search.component";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {SelectItem} from "primeng/components/common/api";
import { CookieService } from 'angular2-cookie/core';
import { User } from '../../model/user';
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS

@Component({
selector: 'visitor-statistics',
templateUrl: 'visitor_log_statistics.html'
})
export class VisitorLogStatisticsComponent implements OnInit {

  // model
  private visitor_list : Visitor[] = [];
  private company_list : ThirdPartyCompany[] = [];

  private conditionList : any[] = [];
  detailSelected : Visitor;
  companySelected : ThirdPartyCompany;

  pageMax:number =10;

  // dialog
  detailShow : boolean = false;
  policyShow : boolean = false;
  detailDialogWidth : number = 700;
  policyDialogWidth : number = 900;

  dateIsTrue : boolean;
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;
  searchIDs: SelectItem[];
  searchText : string;
  searchField : string;
  searchIsTrue : boolean;

  company_items : SelectItem[];
  visitorType_items : SelectItem[];
  osType_items : SelectItem[];
  searchTextDropBox : SelectItem[];

  title : string;

  roleType : string;
  companyType : string;
  companyId: any;

  translate : TranslateServiceForm;

  totalRecord : number = 10;
  today : any;
  ngOnInit() {
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    // this.searchIDs.push({label: '사용자', value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_PhoneNumber'), value: 'mobileNumber'});
    this.searchIDs.push({label: this.translate.instant('LANG_DEVICE_device'), value: 'osType'});
    this.searchIDs.push({label: this.translate.instant('LANG_DeviceStatus'), value: 'visitorType'});
    this.dateIsTrue = false;
    this.searchTextIsDropBox = false;
    this.searchTextIsUse = true;

    this.visitorType_items = [];
    this.visitorType_items.push({label: '---------------', value: ''});
    this.visitorType_items.push({label: this.translate.instant('LANG_PolicyIn'), value: 'DEVICE_POLICY_IN'});
    this.visitorType_items.push({label: this.translate.instant('LANG_PolicyOut'), value: 'DEVICE_POLICY_OUT'});
    this.visitorType_items.push({label: this.translate.instant('LANG_App_Install')+"("+this.translate.instant('AL_ProfileCreateToNormal')+")", value: 'DEVICE_REGISTOR'});
    this.visitorType_items.push({label: this.translate.instant('LANG_App_Delete')+"("+this.translate.instant('AL_ProfileDeleteToNormal')+")", value: 'DEVICE_UNREGISTOR'});

    this.osType_items = [];
    this.osType_items.push({label: '---------------', value: ''});
    this.osType_items.push({label: this.translate.instant('LANG_Android'), value: 'ANDROID'});
    this.osType_items.push({label: this.translate.instant('LANG_iPhone'), value: 'IOS'});
    this.osType_items.push({label: this.translate.instant('LANG_WindowPhone'), value: 'WINDOWS_OS'});
    this.osType_items.push({label: this.translate.instant('Lang_DeviceSumOther'), value: 'OTHER'});


    this.company_items = [];
    this.company_items.push({label: '----------------', value: ''});

    this.getCompanyAdminList();
  }

  constructor(private service : MamAdminService, private visitor_service : MamVisitorService, private cookie : CookieService, private logger : Logger, private _translate : TranslateServiceForm) {
    this.translate = _translate;
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.searchField = event.searchId;
    if(!this.companySelected) {
      alert(this.translate.instant('MESSAGE_Select_Company_First'));
      return;
    }

    if(this.searchField == 'osType' && !this.searchText) {
      alert(this.translate.instant('MESSAGE_Select_OSType'));
      return ;
    }
    this.getVisitorListByCompanyAndSearch(this.companySelected.id, 0, 10, this.searchText, this.searchField);


  }

  paginate(event) {
    if(!this.companySelected) {
      return;
    }
    this.pageMax = event.rows;
    this.logger.debug(event);
    if (this.searchIsTrue) {
      this.getVisitorListByCompanyAndSearch(this.companySelected.id, event.page, event.rows, this.searchText, this.searchField);
    } else {
      this.getVisitorListByCompany(this.companySelected.id, event.page, event.rows);
    }
  }

  getCompanyAdminList() {
    this.service.getCompanyAdminList().subscribe(
        value => {
          this.company_list = value;
        },
        error => { this.logger.error("-- error : " + error); },
        () => {
          if(this.company_list.length > 0) {
            this.company_list.forEach(value => {
              this.company_items.push({label : value.name , value : value});
            })
          }
        }
    )
  }


  getVisitorListByCompany(companyId:number, page:number, max:number) {
    this.visitor_service.getVisitorListByCompany(companyId, page, max).subscribe(
        value => {
          this.visitor_list = value.content;
          this.totalRecord = value.totalElements;
          this.logger.debug(this.totalRecord);
          this.today = new Date();
          this.today.setHours(0,0,0,0);
          console.log(this.today);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {}
    )
  }

  getVisitorListByCompanyAndSearch(companyId:number, page:number, max:number, text:string, field:string) {
    this.visitor_service.getVisitorListByCompanyAndSearch(companyId, page, max, text, field).subscribe(
        value => {
          this.visitor_list = value.content;
          this.totalRecord = value.totalElements;
        },
        error => {this.logger.error("-- error : " + error);},
        () => {})

      }
  actionVisitorPolicyPush(device_id:number) {
    this.visitor_service.actionVisitorPolicyPush(device_id).subscribe(
        value => {
          let result = value;
        },
        error => { this.logger.error("-- error : " + error); },
        () => {
          alert(this.translate.instant('MESSAGE_Policy_Released'));
          this.getVisitorListByCompany(this.companySelected.id, 0, 10);
        }
    )
  }

  getPolicyConditionList(policyId:number, page:number, max:number, data:any) {
    this.service.getPolicyConditionList(policyId,page, max).subscribe(
      value => {
        this.conditionList = value.rows;
      },
      error => { this.logger.error("-- error : " + error); },
      () => {
        this.detailSelected = data;
        this.policyShow = true;
      }
    )
  }

  actionVisitorPush(data) {
    this.actionVisitorPolicyPush(data.device.id);
  }

  actionDetail(data) {
    this.detailShow = true;
    this.detailDialogWidth = 600;
    this.detailSelected = data;
    this.title = this.translate.instant('LANG_Detail');
  }

  showPolicy(data) {
    this.policyShow = true;
    this.title = this.translate.instant('LANG_Policy_Status');
    this.getPolicyConditionList(data.policy.id, 1, 100, data);

  }

  onChange(data) {
    this.logger.debug("onChage data :", data.value);
    if(data.value == '') {
      this.visitor_list = [];
      return;
    }
    this.companySelected = data.value;
    this.getVisitorListByCompany(this.companySelected.id, 0, 10);

  }

  searchTextChange(event) {
    if(event == 'osType') {
      this.searchTextDropBox = this.osType_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;

    } else if(event == 'visitorType') {
      this.searchTextDropBox = this.visitorType_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = true;
    }
  }

  confirm(event){
    this.detailShow = false;
    this.policyShow =false;
  }
}


@NgModule({
  imports: [SearchDropBoxModule, DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,ButtonModule,PaginatorModule, ExDialogModule, SearchModule, DropdownModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [VisitorLogStatisticsComponent],
  declarations: [VisitorLogStatisticsComponent],
  providers: [MamAdminService, MamVisitorService, CookieService],
})
export class VisitorLogStatisticsModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/visitor/visitor_log_statistics.ts